/* Katana Concept Series (Forged) configurator 2026-10-22, buy-online version.
   The Diameter step picks a real variant (its price is the base, per wheel). Every other option step is an upcharge per
   wheel. On submit we add to the cart: the wheel variant x quantity, plus one "Concept Series Option" line per chosen
   upcharge (the option product has one variant per amount), each x quantity, with properties naming the option and the
   wheel it belongs to. Shopify checkout then charges the exact total. Data comes from the JSON block #kxf-data. */
(function () {
  'use strict';
  var wrap = document.querySelector('[data-kxf-form]');
  var form = wrap && wrap.querySelector('form');
  var dataEl = document.getElementById('kxf-data');
  if (!form || !dataEl) return;
  var data = JSON.parse(dataEl.textContent || '{}');
  var addon = data.addon || {};           // { "20000": variantId, ... } price in cents -> variant id
  var money = function (n) {
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(n); }
    catch (e) { return '$' + Math.round(n).toLocaleString(); }
  };
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var qtyEl = form.querySelector('[data-kxf-qty]');
  var submit = form.querySelector('[type="submit"]');
  var errBox = form.querySelector('[data-kxf-error]');

  function qty() { var q = parseInt(qtyEl && qtyEl.value, 10); return q > 0 ? q : 1; }

  function groupValue(g) {
    var r = g.querySelector('input[type="radio"]:checked');
    if (r) return { value: r.value, price: parseFloat(r.getAttribute('data-price')) || 0, note: r.getAttribute('data-note') || '', variant: r.getAttribute('data-variant') || '' };
    var s = g.querySelector('select');
    if (s) { var o = s.options[s.selectedIndex]; if (o && o.value) return { value: o.value, price: parseFloat(o.getAttribute('data-price')) || 0, note: o.getAttribute('data-note') || '', variant: '' }; }
    return null;
  }

  function state() {
    var base = 0, variantId = '', up = 0, lines = [], missing = [];
    Array.prototype.forEach.call(form.querySelectorAll('[data-kxf-group]'), function (g) {
      var v = groupValue(g);
      var pick = g.querySelector('[data-kxf-pick]'), note = g.querySelector('[data-kxf-note]');
      if (!v) { if (pick) pick.innerHTML = ''; if (note) note.textContent = ''; return; }
      var isBase = g.hasAttribute('data-kxf-base');
      var label = g.getAttribute('data-label');
      if (isBase) { base = v.price; variantId = v.variant; }
      else {
        up += v.price;
        if (v.price > 0) {
          var key = String(Math.round(v.price * 100));
          if (addon[key]) lines.push({ label: label, value: v.value, price: v.price, addonId: addon[key] });
          else missing.push(label + ': ' + v.value);
        }
      }
      var free = g.hasAttribute('data-kxf-free');
      var priceTxt = isBase ? money(v.price) : (v.price > 0 ? '+' + money(v.price) : (free ? '' : 'Included'));
      if (pick) pick.innerHTML = '<b>' + esc(v.value) + '</b>' + (priceTxt ? ' &middot; ' + priceTxt : '');
      if (note) note.textContent = v.note;
      state.rows.push({ label: label, value: v.value, price: priceTxt });
    });
    return { base: base, variantId: variantId, up: up, lines: lines, missing: missing };
  }

  function update() {
    state.rows = [];
    var s = state();
    var per = s.base + s.up, q = qty(), total = per * q;
    var dl = form.querySelector('[data-kxf-summary]');
    if (dl) dl.innerHTML = state.rows.map(function (r) { return '<dt>' + esc(r.label) + '</dt><dd>' + esc(r.value) + (r.price ? '<em>' + r.price + '</em>' : '') + '</dd>'; }).join('');
    Array.prototype.forEach.call(document.querySelectorAll('[data-kxf-per]'), function (e) { e.textContent = money(per); });
    Array.prototype.forEach.call(document.querySelectorAll('[data-kxf-total]'), function (e) { e.textContent = money(total); });
    Array.prototype.forEach.call(document.querySelectorAll('[data-kxf-qty-label]'), function (e) { e.textContent = q === 1 ? '1 wheel' : q + ' wheels'; });
    var meta = document.querySelector('[data-kxf-sticky-meta]');
    if (meta) meta.textContent = (state.rows[0] ? state.rows[0].value + ' · ' : '') + q + ' wheels · ' + money(total);
    if (errBox) {
      if (s.missing.length) { errBox.textContent = 'These options cannot be added online yet: ' + s.missing.join(', ') + '. Email us and we will add them to your order.'; errBox.hidden = false; }
      else { errBox.hidden = true; errBox.textContent = ''; }
    }
    if (submit) submit.disabled = !!s.missing.length || !s.variantId;
    return s;
  }

  form.addEventListener('change', update);
  form.addEventListener('input', function (e) { if (e.target === qtyEl) update(); });
  Array.prototype.forEach.call(form.querySelectorAll('[data-kxf-qty-step]'), function (b) {
    b.addEventListener('click', function () { var d = parseInt(b.getAttribute('data-kxf-qty-step'), 10); qtyEl.value = Math.max(1, Math.min(12, qty() + d)); update(); });
  });
  update();

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var bad = form.querySelector(':invalid');
    if (bad) { var step = bad.closest('.kxf-step') || bad; step.scrollIntoView({ behavior: 'smooth', block: 'center' }); if (bad.reportValidity) bad.reportValidity(); return; }
    var s = update();
    if (!s.variantId || s.missing.length) return;
    var q = qty(), per = s.base + s.up;
    var props = {};
    state.rows.forEach(function (r) { props[r.label] = r.value + (r.price && r.price !== 'Included' ? ' (' + r.price + ')' : ''); });
    Array.prototype.forEach.call(form.querySelectorAll('[data-kxf-prop]'), function (inp) { if (inp.value.trim()) props[inp.getAttribute('data-kxf-prop')] = inp.value.trim(); });
    props['Build total'] = money(per) + ' per wheel incl. options';
    var forLabel = data.title + ' ' + (state.rows[0] ? state.rows[0].value : '') + ' x' + q;
    /* Shopify shows the most recently added line first, so add the option lines first and the wheel last. */
    var items = [];
    s.lines.slice().reverse().forEach(function (l) {
      items.push({ id: parseInt(l.addonId, 10), quantity: q, properties: { 'Option': l.label + ': ' + l.value, 'For': forLabel } });
    });
    items.push({ id: parseInt(s.variantId, 10), quantity: q, properties: props });
    submit.disabled = true; var oldText = submit.textContent; submit.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.body && (res.body.description || res.body.message)) || 'Could not add to cart.');
        window.location.href = '/cart';
      })
      .catch(function (err) {
        submit.disabled = false; submit.textContent = oldText;
        if (errBox) { errBox.textContent = err.message; errBox.hidden = false; errBox.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      });
  });

  /* Gallery */
  var stage = document.querySelector('[data-kxf-stage]'), main = stage && stage.querySelector('img');
  var caption = document.querySelector('[data-kxf-caption]'), thumbs = document.querySelectorAll('[data-kxf-thumb]');
  Array.prototype.forEach.call(thumbs, function (b) {
    b.addEventListener('click', function () {
      if (!main) return;
      Array.prototype.forEach.call(thumbs, function (t) { t.setAttribute('aria-current', 'false'); });
      b.setAttribute('aria-current', 'true'); stage.classList.add('is-loading');
      var img = new Image();
      img.onload = function () { main.src = b.getAttribute('data-src'); main.srcset = ''; main.alt = b.getAttribute('data-alt') || ''; stage.classList.remove('is-loading'); };
      img.src = b.getAttribute('data-src');
      if (caption) caption.textContent = b.getAttribute('data-alt') || '';
    });
  });

  /* Mobile sticky bar */
  var sticky = document.querySelector('[data-kxf-sticky]');
  if (sticky && submit && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { var x = en[0]; sticky.classList.toggle('is-visible', !x.isIntersecting && x.boundingClientRect.top > 0); }, { threshold: 0 }).observe(submit);
    var jump = sticky.querySelector('[data-kxf-jump]');
    if (jump) jump.addEventListener('click', function () { submit.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
  }
})();
